jQuery(document).ready(function($) {

    function loadRepurchaseDocs(page = 1) {
        if (typeof current_page_id !== "undefined" && current_page_id !== "" && repurchase_per_page !== "") {
            $.ajax({
                url: localized_object.ajax_url,
                type: "POST",
                data: {
                    action: "load_repurchase_docs",
                    page: page,
                    page_id: current_page_id,
                    per_page: repurchase_per_page
                },
                beforeSend: function() {
                    // Add overlay loader
                    if ($("#repurchase-table .loader-overlay").length === 0) {
                        $("#repurchase-table").append("<div class='loader-overlay'><div class='spinner'></div></div>");
                    }
                },
                success: function(response) {
                    let data = JSON.parse(response);
                    $("#repurchase-table").html(data.html);
                    $("#repurchase-pagination").html(data.pagination);
                },
                complete: function() {
                    // Remove overlay after content loads
                    $("#repurchase-table .loader-overlay").remove();
                }
            });
        }
    }
    

    // load first page
    loadRepurchaseDocs(1);

    // handle pagination click
    $(document).on("click", ".doc-page", function(e) {
        e.preventDefault();
        const nextPage = $(this).data("page");
        loadRepurchaseDocs(nextPage);
    });
});
